$(function () {
    $(".mentorship-course__contact-us-link").fancybox({
        afterLoad: function (instance, current) {
            var trigger = current.opts.$orig;
            var dates = trigger.closest(".mentorship-course__header").find(".mentorship-course__dates").text().trim();

            $("#course-full-overlay-dates").html(dates);
        },
        infobar: false,
        buttons: false,
        smallBtn: false,
        touch: false
    });

    $(".mentorship-course__schedule-link").AjaxButtonLoading({
        submitURL: function () {
            return '/fitness-certifications/live-class/course-schedule/' + this.element.data("course-master-id")
        },
        submitType: 'POST',
        onSuccess: function (response) {
            var classScheduleOverlay = $("#class-schedule-overlay");
            var datesForTitle = this.element.closest(".mentorship-course__header").find(".mentorship-course__dates").text();

            classScheduleOverlay.find(".standard-overlay__title").text("Class Schedule: " + datesForTitle);
            classScheduleOverlay.find(".standard-overlay__body").html(response);

            if (jQuery().fancybox) {
                if ($.fancybox.getInstance() == false) {
                    $.fancybox.open(classScheduleOverlay, {
                        preload: false,
                        modal: true,
                        smallBtn: false,
                        toolbar: false
                    });
                }
            }
        }
    });

    $(".mentorship-course-add-to-cart-btn").AddToCart({
        submitURL: function () {
            return '/fitness-certifications/live-class/add-to-cart-no-auth/' + this.element.data("course-master-id")
        },
        onAddToCartFailure: function (response, status, xhr) {
            if (response.RedirectOnErrorURL) {
                return true;  // cartless process is redirecting
            }
            $.fancybox.open({
                src: "#add-to-cart-failure-overlay",
                type: "inline",
                infobar: false,
                buttons: false,
                smallBtn: false,
                touch: false
            });
            return true;
        }
    });

    $(window).on('load resize orientationchange', function () {
        var slider = $('.benefits__slider');
        if (window.matchMedia("(min-width: 768px) and (max-width: 991px), (min-width: 1200px)").matches) {
            if (slider.hasClass('slick-initialized')) {
                slider.slick('unslick');
            }
        }
        else {
            if (!slider.hasClass('slick-initialized')) {
                slider.slick({
                    infinite: true,
                    prevArrow: '.benefits__slide-prev',
                    nextArrow: '.benefits__slide-next',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: true
                });
            }
        }
    });
});

window.addEventListener("DOMContentLoaded", showMoreCourses, false);

function showMoreCourses() {
    var btnShowMoreCourses = document.getElementById("show-more-courses");
    var hiddenClass = "dis-none";

    if (btnShowMoreCourses) {
        btnShowMoreCourses.addEventListener("click", function () {
            var courses = document.querySelectorAll(".mentorship-course");
            btnShowMoreCourses.classList.add(hiddenClass);

            [].forEach.call(courses, function (course) {
                course.classList.remove(hiddenClass);
            });
        }, false);
    }
}
